<!-- 企业动态 -->
<template>
  <div id="form">
    <el-input v-model.trim="cellphone" placeholder="手机号码或邮箱" v-if="from === 'case-core' || from === 'case-chain' || from === 'case-institution' || from === 'product'"></el-input>
    <el-input v-model.trim="cellphone" placeholder="邮箱地址" v-if="from === 'download-core' || from === 'download-home' || from === 'download-institution'"></el-input>
    <el-input v-model.trim="userName" placeholder="怎么称呼您" v-if="from === 'case-core' || from === 'case-institution' || from === 'download-home' || from === 'product'"></el-input>
    <el-input v-model.trim="companyName" placeholder="您的公司名称" v-if="from === 'case-core' || from === 'case-chain' || from === 'download-core' || from === 'download-home' || from === 'product'"></el-input>
    <el-input v-model.trim="institutionName" placeholder="您所在金融机构名称" v-if="from === 'case-institution' || from === 'download-institution'"></el-input>
    <el-select v-model.trim="companyPart" placeholder="选择企业角色类型"  v-if="from === 'case-chain'">
        <el-option label="我是经销商" value="经销商"></el-option>
        <el-option label="我是供应商" value="供应商"></el-option>
    </el-select>
    <el-select v-model.trim="companyType" placeholder="选择企业类型" v-if="from === 'download-home'">
        <el-option label="我是上市公司/大型国企" value="上市公司/大型国企"></el-option>
        <el-option label="我是银行" value="银行"></el-option>
        <el-option label="我是供应商/经销商" value="供应商/经销商"></el-option>
    </el-select>
    <el-select v-model.trim="industryType" placeholder="选择企业行业类型" v-if="from === 'download-core'">
        <el-option label="建筑工程行业" value="建筑工程行业"></el-option>
        <el-option label="医药流通行业" value="医药流通行业"></el-option>
        <el-option label="零售行业" value="零售行业"></el-option>
        <el-option label="新能源行业" value="新能源行业"></el-option>
        <el-option label="制造行业" value="制造行业"></el-option>
        <el-option label="物流行业" value="物流行业"></el-option>
        <el-option label="其他行业" value="其他行业"></el-option>
    </el-select>
    <el-select v-model.trim="institutionPart" placeholder="您所在金融机构属于" v-if="from === 'download-institution'">
        <el-option label="银行" value="银行"></el-option>
        <el-option label="非银行金融机构" value="非银行金融机构"></el-option>
    </el-select>
    <el-button type="primary" @click="login" :style="disabled ? 'background: #6894f9;' : 'background: #1F5DEA;'" :disabled="disabled">提交</el-button>
  </div>
</template>

<script>
import cookieUtils from '@/assets/js/CookieUtils'
import { isCellphone, isMail, getMainDomain } from '@/assets/js/CommonUtils'
import baseVueOptions from '@/assets/js/BaseVueOptions'

var dataObj = {
  email: 'wanglong.jin@iqunxing.com'
}

export default {
  extends: baseVueOptions,
  data () {
    return {
      code: '', // 场景id
      disabled: false, // 防止多次提交
      cellphone: '', // 联系方式
      userName: '', // 客户姓名
      companyPart: '', // 企业角色
      companyType: '', // 企业类型
      industryType: '', // 企业行业
      companyName: '', // 企业名称
      institutionName: '', // 金融或者机构名称
      institutionPart: '' // 机构还是银行
    }
  },
  props: {
    from: String, // 表单网页来源
    roleType: String
  },
  created () {
    this.changeCode()
  },
  watch: {
    from: function () {
      this.changeCode()
    },
    roleType: function () {
      this.changeCode()
    }
  },
  methods: {
    changeCode () {
      let vm = this
      // 分类
      if (vm.from === 'case-core' && vm.roleType === 'N+1') {
        vm.code = '官网-N+1客户信息' // 对 N+1解决方案 感兴趣的客户
      } else if (vm.from === 'case-core' && vm.roleType === '1+N') {
        vm.code = '官网-1+N客户信息' // 对 1+N解决方案 感兴趣的客户
      } else if (vm.from === 'case-chain') {
        vm.code = '官网-留资客户信息' // 供应商／经销商客户
      } else if (vm.from === 'case-institution') {
        vm.code = '官网-咨询机构客户信息' // 金融机构客户
      } else if (vm.from === 'download-core' && vm.roleType === 'N+1') {
        vm.code = '官网-N+1核心客户信息' // 希望下载「N+1」行业方案的核心企业客户
      } else if (vm.from === 'download-core' && vm.roleType === '1+N') {
        vm.code = '官网-1+N核心客户信息' // 希望下载「1+N」行业方案的核心企业客户
      } else if (vm.from === 'download-home') {
        vm.code = '官网-下载方案客户信息' // 希望下载我们方案的客户
      } else if (vm.from === 'download-institution') {
        vm.code = '官网-下载方案金融客户信息' // 希望下载方案的金融机构客户
      } else if (vm.from === 'product') {
        vm.code = '官网-希望体验平台产品客户信息' // 希望体验「操作平台」的客户
        switch (vm.roleType) {
          case 'core':
            dataObj.role = '核心端'
            break
          case 'chain':
            dataObj.role = '链属端'
            break
          case 'institution':
            dataObj.role = '机构端'
            break
        }
      }
    },
    login () {
      var param = {}
      let vm = this
      vm.disabled = true
      if (vm.from.includes('download')) {
        if (!isMail(vm.cellphone)) {
          vm.$alert('邮箱地址有误，请重新填写邮箱地址', '提示')
          vm.disabled = false
          return
        }
      } else {
        if (!isCellphone(vm.cellphone) && !isMail(vm.cellphone)) {
          vm.$alert('联系方式有误，请重新填写联系方式', '提示')
          vm.disabled = false
          return
        }
      }
      if (vm.from === 'case-core' || vm.from === 'product') {
        if (vm.userName === '') {
          vm.$alert('请填写联系人名字', '提示')
          vm.disabled = false
          return
        }
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示')
          vm.disabled = false
          return
        }
      }
      if (vm.from === 'case-institution') {
        if (vm.userName === '') {
          vm.$alert('请填写联系人名字', '提示')
          vm.disabled = false
          return
        }
        if (vm.institutionName === '') {
          vm.$alert('请填写所在金融机构名称', '提示')
          vm.disabled = false
          return
        }
      }
      if (vm.from === 'case-chain') {
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示')
          vm.disabled = false
          return
        }
        if (vm.companyPart === '') {
          vm.$alert('请选择企业角色类型', '提示')
          vm.disabled = false
          return
        }
      }
      if (vm.from === 'download-core') {
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示')
          vm.disabled = false
          return
        }
        if (vm.industryType === '') {
          vm.$alert('请选择企业行业类型', '提示')
          vm.disabled = false
          return
        }
      }
      if (vm.from === 'download-institution') {
        if (vm.institutionName === '') {
          vm.$alert('请填写所在金融机构名称', '提示')
          vm.disabled = false
          return
        }
        if (vm.institutionPart === '') {
          vm.$alert('请选择金融机构类型', '提示')
          vm.disabled = false
          return
        }
      }
      if (vm.from === 'download-home') {
        if (vm.userName === '') {
          vm.$alert('请填写联系人名字', '提示')
          vm.disabled = false
          return
        }
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示')
          vm.disabled = false
          return
        }
        if (vm.companyType === '') {
          vm.$alert('请选择企业类型', '提示')
          vm.disabled = false
          return
        }
      }
      param.cellphone = '17611405175'
      param.password = '123456yw'
      vm.ajax({
        url: '/api/user/v2/public/login', // f21之后得版本v2改成v3
        type: 'POST',
        data: JSON.stringify(param),
        success: function (res) {
          cookieUtils.set('tk', res.data.token, {
            domain: getMainDomain()
          })
          setTimeout(function () {
            vm.sendMes()
          }, 500)
        }
      })
    },
    sendMes () {
      let vm = this
      switch (vm.code) {
        case '官网-N+1客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userName = vm.userName
          dataObj.companyName = vm.companyName
          break
        case '官网-1+N客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userName = vm.userName
          dataObj.companyName = vm.companyName
          break
        case '官网-留资客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userType = vm.companyPart
          dataObj.companyName = vm.companyName
          break
        case '官网-咨询机构客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userName = vm.userName
          dataObj.companyName = vm.institutionName
          break
        case '官网-N+1核心客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userName = vm.userName
          dataObj.companyName = vm.companyName
          dataObj.industryType = vm.industryType
          break
        case '官网-1+N核心客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userName = vm.userName
          dataObj.companyName = vm.companyName
          dataObj.industryType = vm.industryType
          break
        case '官网-下载方案客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userName = vm.userName
          dataObj.companyName = vm.companyName
          dataObj.companyType = vm.companyType
          break
        case '官网-下载方案金融客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.institutionPart = vm.institutionPart
          dataObj.companyName = vm.institutionName
          break
        case '官网-希望体验平台产品客户信息':
          dataObj.cellphone = vm.cellphone
          dataObj.userName = vm.userName
          dataObj.companyName = vm.companyName
          break
      }
      vm.ajax({
        type: 'POST',
        url: '/api/message/scene/send',
        data: JSON.stringify({
          appId: '1048',
          code: vm.code,
          createBy: 'user',
          data: JSON.stringify(dataObj)
        }),
        success (res) {
          dataObj = { email: 'wanglong.jin@iqunxing.com' }
          vm.$alert('提交成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              vm.disabled = false
              location.reload()
            }
          })
        },
        error (res) {
          vm.disabled = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ModelForm.vue?490e2e83